import * as d3 from 'd3'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export default function solution() {
	const c = document.getElementById('chart')

	if (c) {
		const data = [
			{ label: "穀物", value: 58, color: "#00a199" },
			{ label: "植物カス", value: 24, color: "#f7b52c" },
			{ label: "その他", value: 14, color: "#ffda2a" },
			{ label: "そうこう類", value: 4, color: "#d6f3f1" }
		]

		const width = c.getBoundingClientRect().width
		const height = c.getBoundingClientRect().height
		const radius = Math.min(width, height) / 2

		const svg = d3.select("#chart")
			.attr("width", width)
			.attr("height", height)
			.append("g")
			.attr("transform", `translate(${width / 2}, ${height / 2})`)

		const pie = d3.pie().value(d => d.value)
		const arc = d3.arc().innerRadius(0).outerRadius(radius)

		const arcs = svg.selectAll("g.arc")
			.data(pie(data))
			.enter()
			.append("g")
			.attr("class", "arc")

		const paths = arcs.append("path")
			.attr("d", arc)
			.attr("fill", d => d.data.color)
			.attr("stroke", "#fff")
			.style("stroke-width", "2px")

		arcs.append("text")
			.attr("class", "label")
			.attr("transform", d => `translate(${arc.centroid(d)})`)
			.attr("text-anchor", "middle")
			.text(d => `${d.data.label} (${d.data.value}%)`)

		// アニメーション制御（ScrollTrigger）
		ScrollTrigger.create({
			trigger: c,
			start: "top 80%",
			onEnter: () => {
        c.classList.add('active')
      }
		})
	}
}
